export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "ROLE",
    accessor: "role",
  },
  {
    Header: "EMAIL ID",
    accessor: "email",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "ACTIONS",
    accessor: "actions",
  },
];